import { render, staticRenderFns } from "./myrecord.vue?vue&type=template&id=77b40faa&scoped=true&"
import script from "./myrecord.vue?vue&type=script&lang=js&"
export * from "./myrecord.vue?vue&type=script&lang=js&"
import style0 from "./myrecord.vue?vue&type=style&index=0&id=77b40faa&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b40faa",
  null
  
)

export default component.exports